<template>
  <section>
    <div class="sonAccount">
      <div class="title">子账号管理</div>
      <div class="pad10">
        <el-button type="primary" @click="handleEdit">添加账号</el-button>
      </div>
      <el-table :data="accountList.data" style="width: 100%">
        <el-table-column fixed prop="username" label="账号"></el-table-column>
        <el-table-column prop="departname" label="所属部门"></el-table-column>
        <el-table-column prop="userreal" label="姓名"></el-table-column>
        <el-table-column prop="telephone" label="电话"></el-table-column>

        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="shouxin(scope.row.id)">授信</el-button>
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="fenye"
        background
        layout="prev, pager, next"
        :page-size="accountList.per_page"
        @current-change="currentorder"
        :total="accountList.total"
      ></el-pagination>
    </div>
    <!-- 对话框 -->
    <el-dialog
      title="子账号管理"
      :visible.sync="centerDialogVisible"
      width="70%"
      center
      @close="closeDialog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名" prop="username">
              <el-input v-model="ruleForm.username" :disabled="ruleForm.id?true:false"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" v-if="ruleForm.id">
              <el-input v-model="ruleForm.userpwd" type="password" placeholder="不填写就默认上次密码"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="userpwd" v-else>
              <el-input v-model="ruleForm.userpwd" type="password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属部门" prop="departid">
              <el-select v-model="ruleForm.departid" placeholder="请选择所属部门" style="width:100%">
                <el-option
                  v-for="(item,index) in departmentList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="简介">
              <el-input type="textarea" v-model="ruleForm.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="userreal">
              <el-input v-model="ruleForm.userreal"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="telephone">
              <el-input v-model="ruleForm.telephone" maxlength="11"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
      </span>-->
    </el-dialog>
  </section>
</template>

<script>
export default {
  name: "Order",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      page: 1,
      ruleForm: {
        username: "",
        userpwd: "",
        departid: "",
        telephone: "",
        userreal: "",
        remark: "",
        id: ""
      },
      accountList: [], //子账号列表
      departmentList: [], //部门列表
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        userpwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 3, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        userreal: [
          { required: true, message: "请输入联系人", trigger: "blur" },
          { min: 2, max: 50, message: "长度在 3 到 50 个字符", trigger: "blur" }
        ],
        telephone: [
          { required: true, message: "请输入电话", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" }
        ],
        departid: [{ required: true, message: "请选择部门", trigger: "change" }]
      },
      centerDialogVisible: false
    };
  },
  props: {},
  methods: {
    handleEdit(row) {
      //编辑
      if (row.username) {
        for (let key in this.ruleForm) {
          this.ruleForm[key] = row[key];
        }
      }
      this.centerDialogVisible = true;
    },
    async handleDelete(id) {
      //删除子账号
      let that = this;
      this.$confirm("此操作将删除该数据, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await that.$fetch("shop/subaccount", {
            body: { act: "delete", id }
          });
          that.$message({
            type: "success",
            message: "删除成功!"
          });
          that.getaccountList();
        })
        .catch(() => {});
    },
    submitForm(formName) {
      let {
        username,
        userpwd,
        departid,
        telephone,
        userreal,
        remark,
        id
      } = this.ruleForm;
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let $url = "shop/companyaddstaff";
          if (id) {
            $url = "shop/subaccount";
          }
          let res = await this.$fetch($url, {
            body: {
              act: "edit",
              username,
              userpwd,
              departid,
              id,
              info: { telephone, userreal, remark }
            }
          });
          if (res) {
            this.$message({ type: "success", message: "提交成功" });
            this.centerDialogVisible = false;
            this.getaccountList();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    shouxin(companyid){
        this.$prompt('请输入授信金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
       
        }).then(async({ value }) => {
          // this.$message({
          //   type: 'success',
          //   message: '你的邮箱是: ' + value
          // });
                   let res = await this.$fetch("shop/setauth", {
            body: { companyid, authmoney:value}
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });       
        });
    },
    resetForm(formName) {
      // this.$refs[formName].resetFields();
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
      this.ruleForm.remark = "";
      this.ruleForm.id = "";
    },

    closeDialog() {
      // 关闭对话框回调
      this.resetForm("ruleForm");
    },
    currentorder(e) {
      this.page = e;
    },
    async getdepartmentList() {
      // 获取部门列表
      let departmentList = await this.$fetch("shop/department", {
        body: { act: "list" }
      });
      console.log("部门列表", departmentList);
      this.departmentList = departmentList;
    },
    async getaccountList() {
      // 子账号列表
      let accountList = await this.$fetch("shop/subaccount", {
        body: { act: "list" }
      });
      console.log("子账号列表", accountList);
      for(let i=0;i<accountList.data.length;i++){
        for(let j=0;j<this.departmentList.length;j++){
          if(accountList.data[i].departid==this.departmentList[j].id){
            accountList.data[i]['departname']=this.departmentList[j].name
          }
        }
      }
      this.accountList = accountList;
    }
  },
async mounted() {
  await this.getdepartmentList(); // 获取部门列表
    this.getaccountList(); // 子账号列表
    
  }
};
</script>

<style lang='scss' scoped>
.el-button + .el-button {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/son_account.vue